import React from 'react'

export const CabinetBannerElement = ({banner}) => (
    <div className="booking-banner">
        <a href={banner.target_url} target="_blank"
           rel="noopener noreferrer">
            <img
                src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + banner.image_url}
                alt="banner"/>
        </a>
    </div>
);



